define("shared/components/shared/ui/button", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/utils", "@ember/debug", "ember-concurrency-decorators", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _utils, _debug, _emberConcurrencyDecorators, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/utils",0,"@ember/debug",0,"ember-concurrency-decorators",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!  template-lint-disable require-button-type }}
  <button
    disabled={{or this.isRunning @isDisabled}}
    {{button type=@type size=@size additional=@additional class=(concat @class this.disabledClass)}}
    {{on "click" (if @promise (perform this.promiseHandler) (if @onClick @onClick (noop)))}}
    ...attributes
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{#if (and this.isRunning @runningText)}}
        {{@runningText}}
      {{else}}
        {{this.verifiedText}}
      {{/if}}
    {{/if}}
  </button>
  
  */
  {
    "id": "qB4YTV5s",
    "block": "[[[11,\"button\"],[16,\"disabled\",[28,[37,0],[[30,0,[\"isRunning\"]],[30,1]],null]],[17,2],[4,[38,1],null,[[\"type\",\"size\",\"additional\",\"class\"],[[30,3],[30,4],[30,5],[28,[37,2],[[30,6],[30,0,[\"disabledClass\"]]],null]]]],[4,[38,3],[\"click\",[52,[30,7],[28,[37,5],[[30,0,[\"promiseHandler\"]]],null],[52,[30,8],[30,8],[28,[37,6],null,null]]]],null],[12],[1,\"\\n\"],[41,[48,[30,10]],[[[1,\"    \"],[18,10,null],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,0,[\"isRunning\"]],[30,9]],null],[[[1,\"      \"],[1,[30,9]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[30,0,[\"verifiedText\"]]],[1,\"\\n\"]],[]]]],[]]],[13],[1,\"\\n\"]],[\"@isDisabled\",\"&attrs\",\"@type\",\"@size\",\"@additional\",\"@class\",\"@promise\",\"@onClick\",\"@runningText\",\"&default\"],false,[\"or\",\"button\",\"concat\",\"on\",\"if\",\"perform\",\"noop\",\"has-block\",\"yield\",\"and\"]]",
    "moduleName": "shared/components/shared/ui/button.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::Ui::Button
   * @extends Component
   *
   * This component provides a Wrapper around an HTML button, to quickly create
   * properly styled buttons that can take an action to trigger when the button is clicked.
   *
   * This makes use of the `{{button}}` modifier to apply the correct classes to the target button.
   * The "size", "type", and "additional" arguments are forwarded directly to the `{{button}}` modifier.
   *
   * All HTML Attributes (class, aria-*, data-*, etc.) are automatically applied to the rendered <button ...> tag
   * and are valid attributes on this component.
   *
   * Arguments:
   * - [size] (String) Button Size, Options: "small", "regular", "large" (default: "regular")
   * - [type] (String) Button color styling, Options: "primary", "default", "proceed", "outline", "danger", "mute", "unstyled" (default: "primary")
   * - [additional] (String) Button options, Available options: "rounded", "circle", "block" (default: null)
   * - [text] (String) The text displayed on the button.Required for inline usage. If this component is invoked as a block,
   *   the block contents will be used instead of this property. (default: "")
   * - [runningText] (String) The text displayed when button is running.
   * - [isDisabled] (Boolean) Whether or not the button is disabled (default: false)
   * - [onClick] (action/task) Click handler for button
   * - [promise] (task) Task for button which when handled will disable the button while task is running
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Ui::Button @text="Click Me" />
   * <Shared::Ui::Button @text="Click Me" @size="large" @type="outline" />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::Ui::Button
   *  @text="Click Me"
   *  @size="large"
   *  @type="outline"
   *  @additional="block"
   *  @isDisabled={{true}}
   *  @onClick={{action "handleClick"}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::Ui::Button
   *  @size="regular"
   *  @type="primary"
   *  @onClick={{action "handleClick"}}
   * >
   *  {{#if inputType.isMouse}}
   *    Click Here
   *  {{else}}
   *    Tap Here
   *  {{/if}}
   * </Shared::Button::Upgrade>
   * ```
   */
  let Button = (_class = class Button extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isRunning", _descriptor, this);
    }

    get isDisabled() {
      return this.args.isDisabled || false;
    }

    get verifiedText() {
      (false && !((0, _utils.isPresent)(this.args.text)) && (0, _debug.assert)('The `@text` argument is required with inline usage', (0, _utils.isPresent)(this.args.text)));
      return this.args.text;
    }

    get disabledClass() {
      if (this.isDisabled || this.isRunning) {
        return ' o--btn--disabled';
      }

      return '';
    }

    *promiseHandler() {
      try {
        this.isRunning = true;
        yield this.args.promise.unlinked().perform();
      } finally {
        this.isRunning = false;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isRunning", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "promiseHandler", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "promiseHandler"), _class.prototype)), _class);
  _exports.default = Button;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Button);
});